const SERIALIZATION_VERSION = '1';
const KEY = 'vwa_d6_cms_e-commerce-service';
export class EcommerceStorage {
    constructor(sessionStorage, logger) {
        this.sessionStorage = sessionStorage;
        this.logger = logger;
    }
    persist(data) {
        this.logger.debug('e-commerce-service: storing checkout in storage');
        window.sessionStorage.setItem(KEY, JSON.stringify({ version: SERIALIZATION_VERSION, data }));
    }
    load() {
        const data = this.sessionStorage.getItem(KEY);
        if (data) {
            try {
                const parsedData = JSON.parse(data);
                if (parsedData.version === SERIALIZATION_VERSION) {
                    this.logger.debug('e-commerce-service: successfully loaded checkout from storage');
                    return parsedData.data;
                }
                this.logger.debug('e-commerce-service: discarding incorrect version in storage');
            }
            catch (e) {
                this.logger.error('e-commerce-service: failed to load from storage', e);
                return undefined;
            }
        }
        this.logger.debug('e-commerce-service: no data in storage');
        return undefined;
    }
}
//# sourceMappingURL=storage.js.map